<template>
    <div class="main">
        <h1>{{COMBO_NAME}}</h1>
       
        <div class="tables">
            <h3>套餐内项目</h3>
            <table>
                <thead>
                    <tr>
                        <td>序号</td>
                        <td>项目</td>
                        <td>临床意义</td>
                        <!-- <td>价格</td> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(li,index) in FIXED_ITEMS" :key="index">
                        <td>{{index+1}}</td>
                        <td style="max-width:10em;">{{li.CHECKITEM_NAME}}</td>
                        <td style="max-width:10em;">{{li.MEANING}}</td>
                        <!-- <td>{{li.ITEM_COST}}</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tables">
            <h3>新增项目：</h3>
            <table>
                <thead>
                    <tr>
                        <td>序号</td>
                        <td>项目</td>
                        <td>临床意义</td>
                        <td>价格</td>
                        <td>取消</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(li,index) in ADDITEMS" :key="index">
                        <td>{{index+1}}</td>
                        <td style="max-width:10em;">{{li.CHECKITEM_NAME}}</td>
                        <td style="max-width:10em;">{{li.MEANING}}</td>
                        <td>{{li.ITEM_COST}}</td>
                        <td><i class="iconfont icon-error" @click="cancleItem(index)"></i></td>
                    </tr>
                   
                </tbody>
            </table>
        </div>
        <div class="tctitle">
            <b></b><span>添加其他项目</span><b></b>
        </div>
        <ul class="tctype">
            <li v-for="(li,index) in CATEGORYS" :key="index"><button type="button" @click="begreen(index)" :class="{green:changeGreen==index}"> {{li.NAME}}</button></li>
        </ul>
        <div class="tables">
            <table>
                <thead>
                    <tr>
                        <td>序号</td>
                        <td>项目</td>
                        <td>临床意义</td>
                        <td>价格</td>
                        <td>添加</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(li,index) in CHECKITEMS" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{li.CHECKITEM_NAME}}</td>
                        <td style="max-width:10em;">{{li.MEANING}}</td>
                        <td>{{li.ITEM_COST}}</td>
                        <td><i class="iconfont icon-jia" @click="addItem(index)"></i></td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
        <div class="buy">
            <div class="price">
                <span>总价：¥{{PRICE}}</span>
            </div>
            <button class="btnbuy" @click="submit">立即购买</button>
        </div>

          <van-popup v-model="show" position="bottom">
            <div class="pay">
                <div class="head"><i class="iconfont icon-error" @click="cancle"></i><span>确认付款</span></div>
                <h1>¥{{PRICE}}</h1>
                <ul>
                    <li>
                        <h3>请选择支付方式</h3>
                         <div class="items">
                            <img src="../assets/images/wx.png" alt="">
                            <div>
                                <!-- <h1>微信支付</h1> -->
                                <h2>微信支付</h2>
                                <!-- <h2>微信7.0及以上版本</h2> -->
                            </div>
                            <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.wx}"></i>
                        </div>
                        <!-- <div @click="selwx" class="items">
                            <img src="../assets/images/wx.png" alt="">
                            <div>
                                <h1>微信支付</h1>
                                <h2></h2>
                                <h2>请仔细核对订单，确认付款后不能撤销</h2> 
                            </div>
                            <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.wx}"></i>
                        </div>
                        <div @click="selzfb" class="items">
                            <img src="../assets/images/zfb.png" alt="">
                            <div>
                                <h1>支付宝</h1>
                                <h2>支付宝11.0及以上版本</h2>
                            </div>
                            <i :class="{'iconfont':true,'icon-webicon318':true,'active':this.zfb}"></i>
                        </div> -->
                    </li>
                </ul>
                <van-button @click='pay' size="small">立即付款</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import api from "@/fetch/api";
    import {
        mapGetters
    } from 'vuex';
    import {
        Dialog,
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                CATEGORYS: [],
                CHECKITEMS: [],
                ADDITEMS: [],
                changeGreen: 0,
                PRICE: 0,
                FIXED_ITEMS: [],
                COMBO_NAME: '',
                ADD_PRICE: 0,
                show: false,
                wx: true,
                trade_state: '',
                zfb: false
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getComboInfo(vm)
            })
        },
        
        created() {
            
            api.getItemCat().then(res => {
                res.data.forEach(el => {
                    this.CATEGORYS.push({
                        ITEMCATEGORY_ID: el.ITEMCATEGORY_ID,
                        NAME: el.NAME
                    });
                });
                return this.CATEGORYS[0];
            }).then(v => {
                api.getSingleCheck(v.ITEMCATEGORY_ID).then(re => {
                    re.data.forEach(el => {
                        this.CHECKITEMS.push({
                            CHECKITEM_ID: el.CHECKITEM_ID,
                            CHECKITEM_NAME: el.CHECKITEM_NAME,
                            ITEM_COST: el.ITEM_COST,
                            MEANING: el.MEANING
                        });
                    })
                })
            });
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            getComboInfo(el) {
                this.COMBO_NAME = el.$route.query.COMBO_NAME;
                this.orderID = el.$route.params.orderID;

                 api.queryMyOrderItems(this.orderID).then(re => {
                    let data = re.data;
                    this.ADDITEMS = data.addItems;
                    this.FIXED_ITEMS = data.basicItems;

                    this.PRICE =  parseFloat(this.ADD_PRICE);
                });
               
            },
            begreen(index) {
                this.changeGreen = index;
                api.getSingleCheck(this.CATEGORYS[index].ITEMCATEGORY_ID).then(re => {
                    this.CHECKITEMS = [];
                    re.data.forEach(el => {
                        this.CHECKITEMS.push({
                            CHECKITEM_ID: el.CHECKITEM_ID,
                            CHECKITEM_NAME: el.CHECKITEM_NAME,
                            ITEM_COST: el.ITEM_COST,
                            MEANING: el.MEANING
                        });
                    })
                });
            },
            submit() {
                this.$dialog.confirm({
                    title: '提示',
                    message: '请仔细核对订单，确认付款后不能撤销、不予退款，敬请谅解',
                    cancelButtonText: '不同意',
                    confirmButtonText:'同意'
                }).then(() => {
                    // on confirm
                  this.show = true;
                  
            
                }).catch(() => {
                    // on cancel
                });
            },
            selwx() {
                this.wx = !this.wx;
                this.zfb = false;
            },
            selzfb() {
                this.zfb = !this.zfb;
                this.wx = false;
            },
           newUuid() {
                if (this.trade_state == '') {
                    let len = len || 32;
                    var chars = '0123456789abcdefghijklmnopqrstuvwxyz';
                    let maxPos = chars.length;
                    let uuid = '';
                    for (var i = 0; i < len; i++) {
                        uuid += chars.charAt(Math.floor(Math.random() * maxPos));
                    };
                    this.trade_state = uuid;
                }
            },
            // pay() {

            //     this.show = false;
            //     Toast.loading({
            //         mask: true,
            //         message: '支付中...'
            //     });
                

            //     let addItemIDs = [];
            //     this.ADDITEMS.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
            //     // console.log(addItemIDs);
            //     let params = {
            //         addItemId: addItemIDs,
            //         PRICE: this.PRICE
            //     };
                
            //     api.addGroupItem(this.orderID, this.userInfo.CUSTOMER_ID, params)
            //         .then(res => {
            //             if(res.result==true){
            //                  setTimeout(() => {
            //                 this.$router.push('/user/paySuccess')
            //             }, 3000);
            //             }
            //         });
            // },
            pay() {
                this.show = false;
                Toast.loading({
                    mask: true,
                    message: '支付中...'
                });
                let that = this;
                this.newUuid();
                var data = JSON.parse(sessionStorage.getItem('records'));
                    var url = location.href; 
                    var address = ""
                    console.log(url);
                    if (url.indexOf("?") != -1) { 
                        var str = url.substr(7); 
                        var strs = url.split("&state="); 
                        console.log(strs[1]);
                        address = strs[0]
                    }
                    api.pay(that.PRICE, that.trade_state, that.userInfo.CUSTOMER_ID,address).then(v => {
                        if (v.success == 'ok') {
                            //调用jsAPI
                            if (typeof WeixinJSBridge == undefined) {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                }
                            } else {
                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', {
                                        "appId": v.appid, //公众号名称，由商户传入     
                                        "timeStamp": v.timeStamp, //时间戳，自1970年以来的秒数     
                                        "nonceStr": v.nonceStr, //随机串     
                                        "package": v.package,
                                        "signType": "MD5", //微信签名方式：     
                                        "paySign": v.paySign //微信签名 
                                    },
                                    function(res) {
                                        api.payQuery(that.trade_state).then(re => {
                                            let ret = re.success;
                                            if (ret != undefined) {
                                                if (ret == 'SUCCESS') {
                                                    let addItemIDs = [];
                that.ADDITEMS.forEach(v => addItemIDs.push(v.CHECKITEM_ID));
                // console.log(addItemIDs);
                let params = {
                    addItemId: addItemIDs,
                    PRICE: that.PRICE
                };
                
                api.addGroupItem(that.orderID, that.userInfo.CUSTOMER_ID, params)
                    .then(res => {
                        if(res.result==true){
                             setTimeout(() => {
                            that.$router.push('/user/paySuccess')
                        }, 3000);
                        }
                    });
                                                } else {
                                                    switch (ret) {
                                                        case 'REFUND':
                                                            Toast('转入退款');
                                                            break;
                                                        case 'NOTPAY':
                                                            Toast('未支付');
                                                            break;
                                                        case 'CLOSED':
                                                            Toast('已关闭');
                                                            break;
                                                        case 'REVOKED':
                                                            Toast('已撤销（刷卡支付）');
                                                            break;
                                                        case 'USERPAYING':
                                                            Toast('用户支付中');
                                                            break;
                                                        case 'PAYERROR':
                                                            Toast.fail('支付失败');
                                                            break;
                                                    }
                                                }
                                            } else {
                                                Toast.fail('支付失败');
                                            }
                                        });
                                    });
                            }
                        } else {
                            Toast.fail('内部程序出错');
                        }
                    });
                
            },
            cancle() {
                this.show = false;
            },
            addItem(index) {
                Dialog.confirm({
                    title: '添加项目',
                    message: '确定添加吗？'
                }).then(() => {
                    if (this.ADDITEMS.findIndex(p => p.CHECKITEM_ID === this.CHECKITEMS[index].CHECKITEM_ID) === -1) {
                        this.ADDITEMS.push({
                            CHECKITEM_ID: this.CHECKITEMS[index].CHECKITEM_ID,
                            CHECKITEM_NAME: this.CHECKITEMS[index].CHECKITEM_NAME,
                            ITEM_COST: this.CHECKITEMS[index].ITEM_COST,
                            MEANING: this.CHECKITEMS[index].MEANING
                        });
                        Toast.success('添加成功！');
                    } else {
                        Toast.fail('您已添加该项目！');
                    }
                    let price = 0;
                    this.ADDITEMS.forEach(p => price += p.ITEM_COST);
                    this.PRICE =  parseFloat(price);
                }).catch(() => {
                    // on cancel
                });
            },
            cancleItem(index) {
                Dialog.confirm({
                    title: '取消项目',
                    message: '确定取消吗？'
                }).then(() => {
                    if (this.ADDITEMS.length > index) {
                        this.ADDITEMS.splice(index, 1);
                        let price = 0;
                        this.ADDITEMS.forEach(p => price += p.ITEM_COST);
                        this.PRICE =  parseFloat(price);
                        Toast.success('取消成功！');
                    }
                }).catch(() => {
                    // on cancel
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .main {
        .tables {
            font-size: 0.6rem;
            .iconfont {
                border: 1px solid #aacd06;
                border-radius: 5px;
                font-size: 0.5rem;
                padding: 0.2rem;
                color: #fff;
                background-color: #aacd06;
                font-weight: bold;
            }
        }
        .caption {
            margin: 0.5rem;
        }
        >h1 {
            font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
            font-weight: 700;
            font-style: normal;
            font-size: 1rem;
            color: #43852E;
            text-align: center;
            padding: 0.5em 0;
        }
        b {
            display: inline-block;
            background-color: #66CCCC;
            width: 2px;
            height: 0.8rem;
        }
        span {
            font-size: 0.8rem;
            color: #797979;
            text-align: left;
        }
        >ul {
            zoom: 1;
            margin: 10px;
            li {
                height: 2.5em;
                width: 23%;
                float: left;
                button {
                    // width: 5.1em; 
                    width: 100%;
                    height: 2em;
                    background: inherit;
                    background-color: rgba(255, 255, 255, 1);
                    box-sizing: border-box;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #74b13f;
                    border-radius: 6px;
                    box-shadow: none;
                    color: #74b13f;
                    text-align: center;
                    font-size: 0.8em;
                }
            }
        }
        ul:after {
            display: block;
            clear: both;
            height: 0;
            content: '.';
            visibility: hidden;
        }
        .tctype>li {
            // margin: 0 0.4em;
            margin: 0 1%;
        }
        .tctitle {
            text-align: center;
            height: 2rem;
            b {
                display: inline-block;
                width: 5rem;
                height: 1px;
                background-color: #FF9966;
                vertical-align: middle;
                margin: 0 1rem;
            }
            span {
                font-size: 1rem;
                font-family: 'Arial Negreta', 'Arial Normal', 'Arial'; // font-weight: 700;
                color: #FF9966;
            }
        }
        .buy {
            position: fixed;
            bottom: 0;
            width: 100%;
            border-top: 1px solid #ccc;
            height: 3em;
            line-height: 3em;
            color: #FF9966;
            font-size: 0.6rem;
            background: #fff;
            .btnbuy {
                padding: 0 1.2em;
            }
            button {
                position: absolute;
                top: 0;
                right: 0;
                padding: 0 2em;
                line-height: 3em;
                height: 3em; // background: rgba(102, 204, 204, 1);
                color: #fff;
                border: none;
                box-shadow: -2px -2px 5px rgba(102, 102, 102, 0.349019607843137);
            }
            .line {
                width: 2px;
                height: 2em; // background: #ccc;
                margin-left: 1em;
                position: relative;
                top: 0.5em;
            }
            .price span {
                font-size: 1rem;
                font-weight: bold;
                margin-left: 1rem;
            }
        }
        .buy>div {
            display: inline-block;
        }
        .green {
            background: #74b13f;
            color: #fff;
        }


         .pay {
            .head {
                padding: 0.5em;
                position: relative;
                text-align: center;
                border-bottom: 1px solid rgb(226, 226, 226);
                .iconfont {
                    position: absolute;
                    left: 0.3em;
                    top: 0.4em;
                }
            }
            button {
                background: #99C51D;
                margin: 4em 1em 1em 1em;
                color: #fff;
                font-weight: bold;
                font-size: 1rem;
                width: 95%;
                border-radius: 10px;
                height: 2em;
            }
            h1 {
                text-align: center;
                font-weight: normal;
                padding: 1em 0 0.3em 0;
            }
            ul {
                li {
                    font-size: 0.8rem;
                    color: #333;
                }
            }
            .items {
                border-bottom: 1px solid rgb(226, 226, 226);
                position: relative;
                margin-bottom: 0.4em;
                img {
                    position: absolute;
                    left: 1em;
                    top: 0;
                    width: 2.5em;
                }
                >div {
                    margin-left: 5em;
                    h1 {
                        color: #333;
                    }
                    h2 {
                        color: #999;
                    }
                    h1,
                    h2 {
                        padding: 0;
                        margin: 0;
                        text-align: left;
                        font-size: 0.9em;
                        background: #fff;
                        line-height: 1.5em;
                    }
                }
                i {
                    position: absolute;
                    right: 1em;
                    top: 0.4em;
                    color: #999;
                }
                .active {
                    color: #99C51D;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/tjjx.vue